import logo from '../logo.svg';
import { Typography, Paper, AppBar, Button, Box, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Link, Toolbar, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

<ResponsiveAppBar />

<main>

        <Container maxWidth="lg" className="subPageContainer">

          <Typography variant='h1' className='sectionTitle'>Familie</Typography>

          <Box className='subpageBodyBox'>

            <Typography variant='h2' className='sectionTitle2 subsection'>Heiraten</Typography>
            <Typography variant='body1' className='sectionText textTwoColumns'>
            Wer heiratet, geht mehrere rechtliche Verpflichtungen gegenüber dem anderen Ehegatten ein. Sollten sich die Ehegatten scheiden lassen, muss der besser verdiende Ehegatte dem anderen Ehegatten ggf. einen Geldausgleich zahlen, den sog. Zugewinnausgleich. Darüber hinaus müssen die Ehegatten Rentenanwartschaften neu aufteilen. Unter bestimmten Voraussetzungen muss ein Ehegatte auch nach der Scheidung Unterhalt leisten. Die gesetzlich vorgesehenen Verpflichtungen können der Situation der Eheleute nicht immer gerecht werden. Daher sollten junge Ehegatten sich von einem Notar zu den rechtlichen Folgen einer Eheschließung beraten lassen. Je nach Bedarf kann der Notar größere oder kleinere Modifikationen für den Ausgleich im Falle einer Scheidung vorsehen – seien diese ein Ausschluss oder eine Einschränkung der genannten Regelungen oder auch eine Erweiterung der Rechte – etwa zugunsten des ein Kind erziehenden Elternteils. Dadurch vermeiden die Ehegatten die Gefahr eines teuren und emotional extrem belastenden Rosenkriegs. Einen Ehevetrag können sie bereits vor der Eheschließung im Standesamt und auch jederzeit danach abschließen. 
            </Typography>
            <Button className='btnSecondary'><HashLink smooth to="#">Ehevertrag online abwickeln</HashLink></Button>
          </Box>

          <hr className='hoeizontalLine' />

          <Box className='subpageBodyBox'>
            <Typography variant='h2' className='sectionTitle2 subsection'>Scheidung</Typography>
            <Typography variant='body1' className='sectionText textTwoColumns'>
            Wollen sich Ehegatten scheiden lassen, stellen sich zahlreiche rechtliche Fragen. Derjenige Ehegatte, der im Verlauf der Ehe mehr Vermögen hinzuerworben hat, muss dem anderen Ehegatten einen sog. Zugewinnausgleich zahlen. Außerdem muss jeder Ehegatte dem anderen Ehegatten die Hälfte seiner Rentenanwartschaften abgeben, die er während der Ehezeit erworben hat. Unter bestimmten Voraussetzungen muss ein Ehegatte dem anderen Ehegatten auch nach der Scheidung Unterhalt leisten. Dies gilt insbesondere dann, wenn ein Ehegatte sich um die Erziehung minderjähriger Kinder kümmert. Häufig wollen Ehegatten von diesen gesetzlichen Regeln durch Abschluss einer sog. Scheidungsfolgenvereinbarung abweichen. Haben sie zudem gemeinsam eine Immobilie angeschafft, wollen sie das Eigentum meist auf einen Ehegatten allein übertragen. All diese Vorgänge können die Eheleute bei einem Notar regeln.
            </Typography>
            <Button className='btnSecondary'><HashLink smooth to="#">Scheidungsfolgenvereinbarung online abwickeln</HashLink></Button>
          </Box>

          <hr className='hoeizontalLine' />

          <Box className='subpageBodyBox'>
            <Typography variant='h2' className='sectionTitle2 subsection'>Adoption</Typography>
            <Typography variant='body1' className='sectionText textTwoColumns'>
            Wer eine andere Person adoptieren will, muss dafür dem Familiengericht mehrere Erklärungen vorlegen, die vor einem Notar angegeben wurden. Der Notar berät die Beteiligten über die rechtlichen Folgen der Adoption und reicht die Erklärungen bei dem Familiengericht ein. 
            </Typography>
            <Button className='btnSecondary'><HashLink smooth to="#">Adoption online abwickeln</HashLink></Button>
          </Box>

        </Container>


        <Box className="section bannergrey" id="kontakt">
          <Container maxWidth="lg" className="container" id="kontakt">
            <Box className="kontaktGrid">
              <Box className="kontaktLeftSide">
                <Typography variant='h2' className='sectionTitle white'>
                  Sie haben Fragen?  <br />
                  Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                </Typography>
                <Typography variant='body1' paragraph className='whiteText'>
                  Harbecke & Thelen Notare<br />
                  Holzgasse 29 - 33<br />
                  Siegburg 53721<br />
                </Typography>
              </Box>
              <Contactform />
            </Box>
          </Container>
        </Box>


      </main >
      <Footer />
    </div >
  );
}

export default Imprint;